import {Editor} from '@tinymce/tinymce-react'
import {ErrorMessage} from 'formik'
import React, {useRef, useState} from 'react'
import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import {handleLabelNameChanges} from '../../automation'
import MediaManagerModal from '../MediaManagerModal'
import {stripExternalMedia} from './mediaSrcFilter'

type Props = {
  containerClassName?: string
  label?: any
  limit?: number
  name: string
  initialValue?: any
  rules?: any
  input?: any
  height?: number | undefined
  handleChange: any
  labelClassName?: any
  required?: boolean
  errors?: any
  value?: any
}

const FormTinyMce: React.FC<Props> = ({
  containerClassName,
  limit,
  labelClassName,
  label,
  name,
  initialValue,
  rules,
  input,
  height,
  handleChange,
  required,
  errors,
  value,
  ...rest
}) => {
  const editorRef: any = useRef(null)
  const [mediaManagerModalOpen, setMediaManagerModalOpen] = useState(false)
  const [editorCallBack, setEditorCallBack] = useState<any>()
  const isSingleLanguage = checkMultiLanguage()

  const handleCloseMediaManagerModal = () => {
    setMediaManagerModalOpen(false)
  }

  const callingFunction = (cb: any) => {
    const callBackFile = {
      callback: (downloadLink: string, title: string) => {
        cb(downloadLink, {title})
      },
    }
    setEditorCallBack(callBackFile)
  }

  if (isSingleLanguage && label?.includes('(NP)')) return null

  return (
    <div
      className={label ? 'mb-6' : 'col-lg-6 '}
      data-cy={`${handleLabelNameChanges(name)}-tiny-editor`}
    >
      {label && (
        <label className={`mb-1 fw-bolder fs-6 ${labelClassName || 'col-lg-4'}`}>
          <span className={required ? 'required' : ''}>{label}</span>
        </label>
      )}
      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={initialValue}
        value={value}
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
        // Self-hosted GPL build; required from TinyMCE 7 onwards. Must be this prop —
        // the wrapper overrides a license_key set inside init.
        licenseKey='gpl'
        onEditorChange={(e) => {
          handleChange({target: {name, value: e}})
        }}
        data-cy={`${name}-editor-field`}
        // outputFormat='text'
        init={{
          relative_urls: false,
          remove_script_host: false,
          convert_urls: true,
          // setup: function (ed) {
          //   var maxlength = limit ?? 9999999
          //   var count = 0
          //   ed.on('keydown', function (e) {
          //     count++

          //     if (count > maxlength) {
          //       alert('You have reached the character limit')
          //       e.stopPropagation()
          //       return false
          //     }
          //   })
          // },
          height: height ? height : 550,
          menubar: false,
          toolbar_mode: 'sliding',
          forced_root_block: 'p',
          plugins: [
            'advlist',
            'anchor',
            'autolink',
            'charmap',
            'code',
            'directionality',
            'emoticons',
            'fullscreen',
            'help',
            'image',
            'insertdatetime',
            'link',
            'lists',
            'media',
            'nonbreaking',
            'pagebreak',
            'preview',
            'searchreplace',
            'table',
            'visualblocks',
            'wordcount',
          ],
          toolbar1:
            'bold italic backcolor | alignleft aligncenter alignright alignjustify | ' +
            'undo redo | blocks fontfamily fontsize | ' +
            'bullist numlist outdent indent | ' +
            'removeformat | help | image media | table | code | ltr rtl | emoticons | insertdatetime',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          automatic_uploads: true,
          extended_valid_elements: 'style,link[href|rel]',
          custom_elements: 'style,link,~link',
          file_picker_types: 'image',
          setup: (editor: any) => {
            editor.on('PreInit', () => {
              // parser covers content loaded/pasted in; serializer covers what gets saved
              editor.parser.addAttributeFilter('src', stripExternalMedia(editor))
              editor.serializer.addAttributeFilter('src', stripExternalMedia(editor))
            })
          },
          file_picker_callback: function (cb, value, meta) {
            setMediaManagerModalOpen(true)
            callingFunction(cb)
          },
        }}
        textareaName={name}
        {...rest}
      />
      <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
        <ErrorMessage name={name} component='div' className='field-error-message' />
      </div>

      <MediaManagerModal
        isOpen={mediaManagerModalOpen}
        handleClose={handleCloseMediaManagerModal}
        editorCallBack={editorCallBack}
      />
    </div>
  )
}

export default FormTinyMce
